/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ReviewStatus {
    InReview = 0,
    Invoiced = 1,
    Canceled = 2,
    AwaitingInvoicing = 3,
}
